import React from 'react';
import styles from './ReadMoreButton.module.css';
import { OptimizedMotion } from '../../../shared/ui/optimized-motion/OptimizedMotion';

interface ReadMoreButtonProps {
    onClick: () => void;
}

const ReadMoreButton: React.FC<ReadMoreButtonProps> = ({ onClick }) => {
    return (
        <OptimizedMotion className={styles.buttonsWrapper} type="slide-left" delay={0.6}>
            <button className={styles.button} onClick={onClick}>
                Read More
            </button>
        </OptimizedMotion>
    );
};

export default ReadMoreButton;
